import * as React from 'react';
import { connect } from 'react-redux';
import { DefineSurveyContent } from '../../components/pages/DefineSurveyContent';
import { SurveyStep } from '../../models';
import { IApplicationState } from '../../store';
import { ActionCreators as ClientParticipantActionCreators } from '../../store/ClientParticipantAttributeStore';
import { NavigationActions } from '../../store/NavigationActions';
import { ActionCreators as QuestionModalActionCreators } from '../../store/QuestionModalStore';
import { ActionCreators as SurveyBuilderActionCreators } from '../../store/SurveyBuilderStore';
import { ActionCreators as SurveyActionCreators } from '../../store/SurveyStore';
import { SurveyPageStateSetter } from '../state-setter/SurveyPageStateSetter';
import { PageStateSetterRouteProps } from '../state-setter/SurveyPageStateSetterBase';

export const DefineSurveyContentContainer = connect(
	(state: IApplicationState) => ({
		...state.survey,
		...state.surveyBuilder,
		isQuestionChangesLoading: state.questionChanges.isQuestionChangesLoading,
		userType: state.oidc.user?.profile.userType,
	}),
	{
		...SurveyActionCreators,
		...SurveyBuilderActionCreators,
		...QuestionModalActionCreators,
		...ClientParticipantActionCreators,
		...NavigationActions,
	},
)(DefineSurveyContent);

export class DefineSurveyContentPage extends React.PureComponent<PageStateSetterRouteProps> {
	public render() {
		return (
			<>
				<DefineSurveyContentContainer {...this.props} />
				<SurveyPageStateSetter {...this.props} currentStep={SurveyStep.Define} />
			</>
		);
	}
}
